import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';

import Navbar        from './components/Navbar';
import Footer        from './components/Footer';
import ScrollToTop   from './components/ScrollToTop';

import Home          from './pages/Home';
import About         from './pages/About';
import Services      from './pages/Services';
import Bots          from './pages/Bots';
import SupportServer from './pages/SupportServer';
import Contact       from './pages/Contact';
import Terms         from './pages/Terms';
import Privacy       from './pages/Privacy';
import AuthCallback  from './pages/auth/AuthCallback';
import Docs          from './pages/Docs';
import Blog          from './pages/Blog';
import BlogPost      from './pages/BlogPost';
import NoTwitter     from './pages/NoTwitter';
import RobloxRedirect from './pages/RobloxRedirect';
import Announcement  from './components/Announcement';
import PBackground   from './components/PBackground';
import PageTransition from './components/PageTransition';
import OwnerPanel    from './components/OwnerPanel';

import CodeAssistHome     from './bots/code-assist/CodeAssistHome';
import CodeAssistAbout    from './bots/code-assist/CodeAssistAbout';
import CodeAssistInvite   from './bots/code-assist/CodeAssistInvite';
import CodeAssistFeatures from './bots/code-assist/CodeAssistFeatures';
import CodeAssistUse      from './bots/code-assist/use/CodeAssistUse';

// /code-assist/use/* gets navbar but no footer (app-like)
const NO_FOOTER_ROUTES = ['/code-assist/use'];
const NO_CHROME_ROUTES = ['/ZSB8T12T'];

function Layout({ children }) {
  const { pathname } = useLocation();
  const noFooter   = NO_FOOTER_ROUTES.some(r => pathname.startsWith(r));
  const isAppRoute = NO_FOOTER_ROUTES.some(r => pathname.startsWith(r));
  const noChrome   = NO_CHROME_ROUTES.some(r => pathname.startsWith(r));

  if (noChrome) return <>{children}</>;

  return (
    <>
      <PBackground />
      <Navbar />
      <Announcement />
      <OwnerPanel />
      <main style={isAppRoute ? {
        height: '100vh',
        paddingTop: 'var(--nav-height)',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
      } : {}}>
        {children}
      </main>
      {!noFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <PageTransition>
          <Routes>
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="/home"           element={<Home />} />
          <Route path="/about"          element={<About />} />
          <Route path="/services"       element={<Services />} />
          <Route path="/bots"           element={<Bots />} />
          <Route path="/support-server" element={<SupportServer />} />
          <Route path="/contact"        element={<Contact />} />
          <Route path="/terms"          element={<Terms />} />
          <Route path="/privacy"        element={<Privacy />} />
          <Route path="/auth/callback"  element={<AuthCallback />} />
          <Route path="/docs"           element={<Docs />} />
          <Route path="/blog"           element={<Blog />} />
          <Route path="/blog/:slug"     element={<BlogPost />} />
          <Route path="/we-do-not-have-a-twitter-account" element={<NoTwitter />} />
          <Route path="/ZSB8T12T/game/join" element={<RobloxRedirect />} />
          <Route path="/code-assist/home"     element={<CodeAssistHome />} />
          <Route path="/code-assist/about"    element={<CodeAssistAbout />} />
          <Route path="/code-assist/invite"   element={<CodeAssistInvite />} />
          <Route path="/code-assist/features" element={<CodeAssistFeatures />} />
          <Route path="/code-assist/use/home" element={<CodeAssistUse />} />
          <Route path="*" element={<Navigate to="/home" replace />} />
        </Routes>
        </PageTransition>
      </Layout>
    </Router>
  );
}

export default App;